import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";

const name = 'onlineTest';

const initialState = {
    quizInfo: {},
    answer: {},
    noAnswer: {}
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setQuizInfo(state, action) {
            state.quizInfo = json.toJSON(action.payload);
        },
        setAnswer(state, action) {
            state.answer = json.toJSON(action.payload);
        },
        setNoAnswer(state, action) {
            state.noAnswer = json.toJSON(action.payload);
        }
    }
});

export const { setQuizInfo, setAnswer, setNoAnswer } = slice.actions;

export const selectQuizInfo = state => json.fromJSON(state[name].quizInfo);
export const selectAnswer = state => json.fromJSON(state[name].answer);
export const selectNoAnswer = state => json.fromJSON(state[name].noAnswer);

const onlineTestReducer = slice.reducer;
export default onlineTestReducer;